var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 556.3 228",
    style: {
      enableBackground: "new 0 0 556.3 228"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1776BA;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#414042;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,0H148c12.6,0,22.8,10.2,22.8,22.8V148c0,12.6-10.2,22.7-22.8,22.7H22.7C10.2,170.7,0,160.6,0,148V22.8 C0,10.2,10.2,0,22.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,38.5v85.9H16.4V38.5c0-15.6,7.8-23.4,23.4-23.4c6.6,0,11.8,1.4,15.6,4.2c3.8-2.8,9-4.2,15.6-4.2 c15.6,0,23.4,7.8,23.4,23.4v85.9H78.9V38.5c0-5.2-2.6-7.8-7.8-7.8c-5.2,0-7.8,2.6-7.8,7.8v85.9H47.7V38.5c0-5.2-2.6-7.8-7.8-7.8 C34.7,30.7,32,33.3,32,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.4,101V46.3h15.6V101c0,5.2,2.6,7.8,7.8,7.8c5.2,0,7.8-2.6,7.8-7.8V46.3h15.6v85.9 c0,15.6-7.8,23.4-23.4,23.4s-23.4-7.8-23.4-23.4h15.6c0,5.2,2.6,7.8,7.8,7.8s7.8-2.6,7.8-7.8v-15.6c-2.3,5.2-4.9,7.8-7.8,7.8 C115.2,124.4,107.4,116.6,107.4,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,14.8v109.3h-15.6V14.8H200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.2,69.4c0-15.6,7.8-23.4,23.4-23.4c15.6,0,23.4,7.8,23.4,23.4v23.4h-31.2v7.8c0,5.2,2.6,7.8,7.8,7.8 c5.2,0,7.8-2.6,7.8-7.8h15.6c0,15.6-7.8,23.4-23.4,23.4c-15.6,0-23.4-7.8-23.4-23.4V69.4z M236.6,61.6c-5.2,0-7.8,2.6-7.8,7.8v7.8 h15.6v-7.8C244.5,64.2,241.9,61.6,236.6,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.4,61.6c-5.2,0-7.8,2.6-7.8,7.8H273c0-15.6,7.8-23.4,23.4-23.4s23.4,7.8,23.4,23.4v54.7h-15.6v-7.8 c-2.3,5.2-4.9,7.8-7.8,7.8c-15.6,0-23.4-7.8-23.4-23.4s7.8-23.4,23.4-23.4h7.8v-7.8C304.2,64.2,301.6,61.6,296.4,61.6z  M296.4,92.9c-5.2,0-7.8,2.6-7.8,7.8c0,5.2,2.6,7.8,7.8,7.8c5.2,0,7.8-2.6,7.8-7.8v-7.8H296.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.2,46c15.6,0,23.4,7.8,23.4,23.4H364c0-5.2-2.6-7.8-7.8-7.8c-5.2,0-7.8,2.6-7.8,7.8 c0,5.2,2.6,7.8,7.8,7.8c15.6,0,23.4,7.8,23.4,23.4s-7.8,23.4-23.4,23.4c-15.6,0-23.4-7.8-23.4-23.4h15.6c0,5.2,2.6,7.8,7.8,7.8 c5.2,0,7.8-2.6,7.8-7.8c0-5.2-2.6-7.8-7.8-7.8c-15.6,0-23.4-7.8-23.4-23.4S340.6,46,356.2,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.6,69.4c0-15.6,7.8-23.4,23.4-23.4s23.4,7.8,23.4,23.4v23.4h-31.2v7.8c0,5.2,2.6,7.8,7.8,7.8 s7.8-2.6,7.8-7.8h15.6c0,15.6-7.8,23.4-23.4,23.4s-23.4-7.8-23.4-23.4L392.6,69.4z M416,61.6c-5.2,0-7.8,2.6-7.8,7.8v7.8h15.6 v-7.8C423.8,64.2,421.2,61.6,416,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.8,100.7c0,15.6-7.8,23.4-23.4,23.4c-2.9,0-5.5-2.6-7.8-7.8v39.1h-15.6V46h15.6v7.8 c2.3-5.2,4.9-7.8,7.8-7.8c15.6,0,23.4,7.8,23.4,23.4V100.7z M504.4,108.5c5.2,0,7.8-2.6,7.8-7.8V69.4c0-5.2-2.6-7.8-7.8-7.8 c-5.2,0-7.8,2.6-7.8,7.8v31.2C496.5,105.9,499.1,108.5,504.4,108.5L504.4,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.3,14.8v109.3h-15.6V14.8H556.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M466,108.5v15.6h-15.7v-15.6H466z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.9,199.6H66.6v-8.2h32.8v8.2H88.2V228H77.9V199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.8,191.3L148,228h-11.1l-7-22.3l-7.3,22.3h-11.1l-11.9-36.6h10.7l7.4,23.4l7.7-23.4h9.5l7.4,23.6l7.7-23.6 H159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.1,226.2c-3.1-1.6-5.5-3.9-7.3-6.8c-1.8-2.9-2.6-6.2-2.6-9.8c0-3.6,0.9-6.9,2.6-9.8 c1.8-2.9,4.2-5.2,7.3-6.8c3.1-1.6,6.6-2.5,10.4-2.5c3.9,0,7.3,0.8,10.4,2.5c3.1,1.6,5.5,3.9,7.3,6.8c1.8,2.9,2.6,6.2,2.6,9.8 c0,3.6-0.9,6.9-2.6,9.8c-1.8,2.9-4.2,5.2-7.3,6.8c-3.1,1.6-6.6,2.5-10.4,2.5C177.7,228.7,174.2,227.9,171.1,226.2z M186.6,218.8 c1.5-0.9,2.7-2.1,3.6-3.7c0.9-1.6,1.3-3.4,1.3-5.5c0-2.1-0.4-3.9-1.3-5.5s-2.1-2.8-3.6-3.7c-1.5-0.9-3.2-1.3-5-1.3s-3.5,0.4-5,1.3 c-1.5,0.9-2.7,2.1-3.6,3.7c-0.9,1.6-1.3,3.4-1.3,5.5c0,2.1,0.4,3.9,1.3,5.5c0.9,1.6,2.1,2.8,3.6,3.7c1.5,0.9,3.2,1.3,5,1.3 S185.1,219.7,186.6,218.8z M183.4,180.4h9.9l-9.8,7.9h-7.1L183.4,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.2,227.3c-2.2-0.9-4-2.3-5.4-4l5.6-6.7c2,2.5,4.1,3.8,6.3,3.8c1.5,0,2.6-0.5,3.4-1.4 c0.8-0.9,1.2-2.2,1.2-4v-15.7h-12.7v-8h22.9v23.1c0,4.7-1.2,8.3-3.6,10.7c-2.4,2.4-5.9,3.6-10.5,3.6 C211.9,228.7,209.4,228.2,207.2,227.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.3,193c2.4,1.1,4.3,2.7,5.6,4.7c1.3,2,2,4.4,2,7.2c0,2.8-0.7,5.1-2,7.2c-1.3,2-3.2,3.6-5.6,4.7 c-2.4,1.1-5.3,1.6-8.6,1.6h-6.4v9.6h-10.4v-36.6h16.7C270.9,191.3,273.8,191.9,276.3,193z M271.8,208.8c1.1-0.9,1.6-2.2,1.6-3.9 c0-1.7-0.5-3-1.6-4c-1.1-0.9-2.7-1.4-4.8-1.4h-5.8v10.7h5.8C269.1,210.2,270.7,209.8,271.8,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.6,220.8h-15.5l-2.9,7.1h-10.6l16.2-36.6h10.2l16.2,36.6h-10.8L311.6,220.8z M308.6,213.2l-4.7-11.7 l-4.7,11.7H308.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.2,218.2h-5.6v9.7h-10.4v-36.6h16.7c3.3,0,6.2,0.5,8.6,1.6c2.4,1.1,4.3,2.7,5.6,4.7c1.3,2,2,4.4,2,7.2 c0,2.7-0.6,5-1.9,6.9c-1.2,2-3,3.5-5.3,4.6l7.9,11.5h-11.1L344.2,218.2z M349.1,200.9c-1.1-0.9-2.7-1.4-4.8-1.4h-5.8v10.7h5.8 c2.1,0,3.7-0.5,4.8-1.4c1.1-0.9,1.6-2.2,1.6-3.9C350.7,203.2,350.2,201.9,349.1,200.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.2,199.6h-11.2v-8.2h32.8v8.2h-11.2V228h-10.4V199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M434.4,191.3V228h-8.5l-16.2-19.5V228h-10.1v-36.6h8.5l16.2,19.5v-19.5H434.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M471.1,220v8h-29.4v-36.6h28.7v8H452v6.2h16.3v7.7H452v6.7H471.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492.9,218.2h-5.6v9.7h-10.4v-36.6h16.7c3.3,0,6.2,0.5,8.6,1.6c2.4,1.1,4.3,2.7,5.6,4.7c1.3,2,2,4.4,2,7.2 c0,2.7-0.6,5-1.9,6.9c-1.2,2-3,3.5-5.3,4.6l7.9,11.5h-11.1L492.9,218.2z M497.8,200.9c-1.1-0.9-2.7-1.4-4.8-1.4h-5.8v10.7h5.8 c2.1,0,3.7-0.5,4.8-1.4c1.1-0.9,1.6-2.2,1.6-3.9C499.4,203.2,498.9,201.9,497.8,200.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "W17NXv.tif"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 768,
    height: 944,
    id: "Layer_0",
    xlinkHref: "5B326477066A1C19.png",
    transform: "matrix(0.5 0 0 0.5 429 865.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a770d5be66c141bc78d903dc552db4de.svg";
export { ForwardRef as ReactComponent };